export function initFilter() {
  const groups = document.querySelectorAll('[data-filter-group]');
  groups.forEach(group => {
    const tabs = group.querySelectorAll('[data-filter-tab]');
    const container = document.querySelector('[data-filter-container]');
    if (!container) return;
    const cards = container.querySelectorAll('[data-card]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const category = tab.dataset.filterTab;

        tabs.forEach(t => {
          t.setAttribute('aria-pressed', 'false');
          t.classList.remove('filter-tab--active');
        });
        tab.setAttribute('aria-pressed', 'true');
        tab.classList.add('filter-tab--active');

        cards.forEach(card => {
          card.hidden = category !== 'sve' && card.dataset.category !== category;
        });
      });
    });
  });
}

export function initLoadMore() {
  // ARCHIVED: pagination disabled — all cards shown on load, no batch reveal.
  // To restore: uncomment the block below and re-enable the button markup in
  // regulatorni-okvir.astro / en/regulatory-framework.astro.
  /*
  const btn = document.querySelector('[data-filter-load-more]');
  if (!btn) return;
  const container = document.querySelector('[data-filter-container]');
  if (!container) return;

  const cards = Array.from(container.querySelectorAll('[data-card]'));
  const PAGE = 10;
  let shown = PAGE;

  cards.slice(PAGE).forEach(card => { card.hidden = true; });

  if (cards.length <= PAGE) { btn.hidden = true; return; }

  btn.addEventListener('click', () => {
    cards.slice(shown, shown + PAGE).forEach(card => { card.hidden = false; });
    shown = Math.min(shown + PAGE, cards.length);
    if (shown >= cards.length) btn.hidden = true;
  });
  */
}
